export default __webpack_public_path__ + "static/media/wifi_Icon.01e1eab6.svg";